






















































































































































































































































































import { Component, Vue } from "vue-property-decorator";
import { mapGetters, mapState } from "vuex";
import ApiSimulador from "@/plugins/ApiSimulador";
import RdStation from "@/plugins/RdStation";
import CheckIcon from "vue-material-design-icons/Check.vue";
import CancelIcon from "vue-material-design-icons/Cancel.vue";
import DadosTitular from "@/components/dados/DadosTitular.vue";
import DadosEmail from "@/components/dados/DadosEmail.vue";
import DadosDdd from "@/components/dados/DadosDdd.vue";
import DadosTelefone from "@/components/dados/DadosTelefone.vue";
import DadosCep from "@/components/dados/DadosCep.vue";
import DadosLogradouro from "@/components/dados/DadosLogradouro.vue";
import DadosNumero from "@/components/dados/DadosNumero.vue";
import DadosBairro from "@/components/dados/DadosBairro.vue";
import DadosCpf from "@/components/dados/DadosCpf.vue";
import DadosCartao from "@/components/dados/DadosCartao.vue";
import ShieldIcon from 'vue-material-design-icons/Shield.vue';
import ResumoProsseguir from "@/components/resumo/ResumoProsseguir.vue";
import DadosValidade from "@/components/dados/DadosValidade.vue";
import DadosSeguranca from "@/components/dados/DadosSeguranca.vue";
import CardForm from "@/components/form/CardForm.vue";
import Card from "@/components/form/Card.vue";
import axios from "axios";

@Component({
  components: { CheckIcon,
        CancelIcon,
        DadosTelefone,
        DadosDdd,
        DadosTitular,
        DadosEmail,
        DadosCep,
        DadosLogradouro,
        DadosNumero,
        DadosBairro,
        DadosCpf,
        DadosCartao,
        ShieldIcon,
        ResumoProsseguir,
        DadosValidade,
        DadosSeguranca,
        CardForm,
        Card },
    computed:   {
        ...mapState(['cotacao']),
        ...mapGetters(['valor_mensalidade', 'veiculo_ano', 'get_email']),
    }
})
export default class Resumo extends Vue {
  public timeout = 0;
  public cartao = "";
  public cepMask = "#####-###";

  public data = "";
  public messageCep = "";
  public result = false;

  get cep () {
      return this.$store.state.endereco.cep;
  }

  set cep ( value ) {
      this.$store.commit("SET_CEP", value);
  }

  get cidade_uf () {
      return this.$store.state.endereco.cidade_uf;
  }

  set cidade_uf ( value ) {
      this.$store.commit("SET_CIDADE_UF", value);
  }

  get bairro () {
      return this.$store.state.endereco.bairro;
  }

  set bairro ( value ) {
      this.$store.commit("SET_BAIRRO", value);
  }
  get logradouro () {
      return this.$store.state.endereco.logradouro;
  }

  set logradouro ( value ) {
      this.$store.commit("SET_LOGRADOURO", value);
  }
    get complemento () {
      return this.$store.state.endereco.complemento;
  }

  set complemento ( value ) {
      this.$store.commit("SET_COMPLEMENTO", value);
  }

  public searchCep () {
    if(this.cep.length == 9) {
      axios.get(`https://viacep.com.br/ws/${ this.cep }/json/`)
        .then( response => {
          this.logradouro = response.data.logradouro;
          this.bairro = response.data.bairro;
          this.complemento = response.data.complemento;
          this.cidade_uf = response.data.localidade.concat(' - ', response.data.uf);
          this.result = true;
        })
      .catch( error => console.log(error) )
    }
  }

  get errorCep () {
      return this.$store.state.errors.cep;
  }

  public mounted() {
    this.$store.commit('SET_SIDEBAR_ENABLED', true);
    this.$store.commit("SET_SIDEBAR_SHOWING", this.$vuetify.breakpoint.smAndUp);
  }

  public beforeDestroy() {
     clearTimeout(this.timeout);
  }

  get protocolo() {
    return this.$store.state.cotacao.protocolo;
  }

  get preco() {
    return this.$store.getters.valor_fipe;
  }
  get placa () {
      return this.$store.state.placa;
  }

  get marca () {
      return this.$store.state.placa.marca;
  }

  get modelo () {
      return this.$store.state.placa.modelo;
  }

  get ano () {
      return this.$store.state.placa.ano;
  }

  get combustivel () {
      return this.$store.state.placa.combustivel;
  }

  get valor_fipe () {
      return this.$store.state.placa.valor_fipe;
  }


  public sendInteresse ( interesse: boolean ) {
    const baseUrl = "//simulador.protruck.org.br/interesse";
    let pagina = '';

    let resposta = '';

    if (interesse) {
        resposta = 'Sim';
        pagina = "sim";
    } else {
        resposta = 'Não';
        pagina = "nao";
    }

    ApiSimulador.update({
      id: this.$store.state.cotacao.id,
      interesse: resposta,
    }).then(() => {
      RdStation.conversion({
        'identificador': `Interesse: ${resposta}` ,
        'Interesse em contratação': resposta,
        'email': this.$store.getters.get_email,
      }).then();
    });

    window.location.href = `${baseUrl}/${pagina}.php?id=${this.protocolo}`;
  }
}
